export default {
    methods: {
        isExtraSmallBreakpoint() {
            return this.$vuetify.breakpoint.xs;
        },
        isSmallBreakpoint() {
            return this.$vuetify.breakpoint.sm;
        },
        isMediumBreakpoint() {
            return this.$vuetify.breakpoint.md;
        },
        isLargeBreakpoint() {
            return this.$vuetify.breakpoint.lg;
        },
        isExtraLargeBreakpoint() {
            return this.$vuetify.breakpoint.xl;
        },
        isWiderScreen() {
            return this.isMediumBreakpoint() || this.isLargeBreakpoint() || this.isExtraLargeBreakpoint();
        },
        isSmallerScreen() {
            return this.isExtraSmallBreakpoint() || this.isSmallBreakpoint();
        }
    }
}
